<div class="template3">
  <div class="">
    <button class="upload" (click)="openUploadFileModal()">Upload File</button>
  </div>

  <modal #uploadFileModal >
    <modal-header>
      <div>File Uploader</div>
    </modal-header>
    <modal-content>
      <div class="">
        <label id="attachFile-btn"  (keyup.enter)="fileSelect.click()" for="attachFile" class=""
            title="{{'Choose File'}}">
            <span aria-hidden="true">{{'Choose File'}}</span>
            <input #fileSelect type="file" id="attachFile"
            ng2FileSelect [uploader]="uploader"
            role="file" aria-label="browse" >
        </label>
    </div>
    <div class="pull-right mt-20">
      <button id="createAttach-btn" class="btn blue-button" tabindex="0" (keyup.enter)="saveAttachments()" (click)="saveAttachments()">
          {{'ADD'}}
      </button>
      <button class="btn grey-button" tabindex="0"  (keyup.enter)="closeAttachmentPopUp()" (click)="closeAttachmentPopUp()">
          {{'CANCEL'}}
      </button>
  </div>
    </modal-content>
  </modal>

</div>



// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/upload-media.component.html